import { render, staticRenderFns } from "./jianchashebei.vue?vue&type=template&id=19c0e4dc&scoped=true"
import script from "./jianchashebei.vue?vue&type=script&lang=ts"
export * from "./jianchashebei.vue?vue&type=script&lang=ts"
import style0 from "./jianchashebei.vue?vue&type=style&index=0&id=19c0e4dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0e4dc",
  null
  
)

export default component.exports